<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("distributor", 2) }}
      </div>
      <router-link class="btn-blue" to="distributors"
        >{{ $tc("distributor", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <!-- CINEMAS SELECTION -->
          <div
            v-for="(item, index) in Distributors"
            :key="index"
            v-if="item.fieldname !== 'd_id' && false"
            class="col-lg-6 col-xl-4 mb-2 align-self-center"
          >
            <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
              <div class="d-flex align-items-center">
                <div class="input-material d-flex align-items-center">
                  <div v-if="item.fieldname === 'd_fax_no'" class="col-4 pl-0">
                    <!--  -->
                    <b-dropdown
                      :text="fax_country_code ? fax_country_code : 'Code'"
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      name="countrycode"
                      id="countrycode"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          v-validation="Distributor[4]['validation']"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in countryList"
                        :key="countryIndex"
                        v-on:click="
                          onSelectHandler('fax_country_code', countrycode)
                        "
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--  -->
                  </div>
                  <div
                    v-if="item.fieldname === 'd_contact_no'"
                    class="col-4 pl-0"
                  >
                    <!--  -->
                    <b-dropdown
                      :text="SelectedCountryCode ? SelectedCountryCode : 'Code'"
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      name="countrycode"
                      id="countrycode"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in countryList"
                        :key="countryIndex"
                        v-on:click="onSelectHandler('countrycode', countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <!--  -->
                  </div>
                  <div class="position-relative w-100">
                    <input
                      @focus="onFocusHandler"
                      placeholder="."
                      :type="item.type"
                      :name="item.fieldname"
                      :id="item.fieldname"
                      v-validate="
                        item.fieldname == 'd_tin_number'
                          ? { regex: /^[a-zA-Z0-9-.]+$/ }
                          : item.validation
                      "
                      v-model="item.fieldvalue"
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    />
                    <label>{{ $tc(item.label, 1) }}</label>
                  </div>
                </div>
                <!--Tooltip :title="$t(item.tooltip)" /--->
              </div>
              <p class="error_message">
                <!-- <span v-if="submitted && errors.has(item.fieldname)">{{
                  errors.first(`${item.fieldname}`)
                }}</span> -->
                <span v-if="submitted && errors.has(item.fieldname)">
                  <!-- {{errors.first(`${item.fieldname}`)}}  -->
                  <!-- {{ $t(item.errormsg) }} -->
                  {{
                    item.type == "number"
                      ? $t(item.errormsg)
                      : errors.first(`${item.fieldname}`)
                  }}
                </span>
              </p>
            </div>

            <div v-if="item.fieldname == 'd_default_contract'">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <multiselect
                    v-model="selected_contract_id"
                    @select="onSelectContract($event, index)"
                    :placeholder="item.placeholder"
                    :options="contracts"
                    label="contract_weekwise_name"
                    track-by="cbw_id"
                    :multiple="false"
                    v-b-tooltip.hover
                    :title="$t('select_contract_tooltip')"
                  ></multiselect>
                </div>
                <!--Tooltip :title="$t('select_contract_tooltip')" /--->
              </div>
              <p class="error_message">
                <span v-if="submitted && selected_contract_id == null"
                  >Please select weekwise contract.</span
                >
              </p>
            </div>

            <div class="d-flex align-items-center" v-if="item.type === 'radio'">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>

            <div v-if="item.type === 'dropdown'">
              <div v-if="item.fieldname === 'parent_distributor_id'">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="item.dropdownSelected.length ? 'shift-up' : ''"
                      >{{ $tc(item.label, 1) }}</label
                    >
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Parent Distributor"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchParent()"
                          v-on:keydown="onSearchParent()"
                          v-on:search="onSearchParent()"
                          v-model="searchParent"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(dropdownItem, dropdownIndex) in distributorList"
                        :key="dropdownIndex"
                        @click="
                          onDropdownChange(
                            $event,
                            item.label,
                            dropdownItem,
                            index
                          )
                        "
                        >{{ dropdownItem.d_company_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <!--Tooltip :title="$t(item.tooltip)" /-->
                </div>
                <p class="error_message"></p>
              </div>

              <div v-if="item.fieldname === 'country_id'">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <multiselect
                      :options="countryList"
                      v-model="selected_country"
                      :searchable="true"
                      label="country_name"
                      track-by="country_name"
                      placeholder="Select Country"
                      @select="onSelectCountry($event, index)"
                      @remove="onRemoveCountry(index)"
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    ></multiselect>
                  </div>

                  <!--Tooltip :title="$t(item.tooltip)" /--->
                </div>
                <p class="error_message">
                  <!-- <span v-if="submitted && selected_country == null"
                    >Please select country.</span
                  > -->
                </p>
              </div>

              <div v-if="item.fieldname === 'state_id'">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <!-- <label
                      :class="item.dropdownSelected.length ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label>
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem,dropdownIndex) in stateList"
                        :key="dropdownIndex"
                        @click="onDropdownChange($event, item.label,dropdownItem, index)"
                      >{{ dropdownItem.state_name }}</b-dropdown-item>
                    </b-dropdown>-->
                    <multiselect
                      :options="stateList"
                      v-model="selected_state"
                      :searchable="true"
                      label="state_name"
                      track-by="state_name"
                      placeholder="Select State"
                      @select="onSelectState($event, index)"
                      @remove="onRemoveState(index)"
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    ></multiselect>
                  </div>
                  <!--Tooltip :title="$t(item.tooltip)" /--->
                </div>
                <p class="error_message">
                  <!-- <span v-if="submitted && selected_state == null"
                    >Please select state.</span
                  > -->
                </p>
              </div>

              <div v-if="item.fieldname === 'city_id'">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <!-- <label
                      :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label>
                    <b-dropdown
                      :text="item.dropdownSelected"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(dropdownItem,dropdownIndex) in cityList"
                        :key="dropdownIndex"
                        @click="onDropdownChange($event, item.label,dropdownItem, index)"
                      >{{ dropdownItem.city_name }}</b-dropdown-item>
                    </b-dropdown>-->
                    <multiselect
                      :options="cityList"
                      v-model="selected_city"
                      :searchable="true"
                      label="city_name"
                      track-by="city_name"
                      placeholder="Select City"
                      @select="onSelectCity($event, index)"
                      @remove="onRemoveCity(index)"
                      v-b-tooltip.hover
                      :title="$t(item.tooltip)"
                    ></multiselect>
                  </div>

                  <!--Tooltip :title="$t(item.tooltip)" /--->
                </div>

                <p class="error_message">
                  <!-- <span v-if="submitted && selected_city == null"
                    >Please select city.</span
                  > -->
                </p>
              </div>
            </div>
          </div>

          <!--New Design-->

          <div class="row row mx-3 back rounded-10 new-border pt-3 mb-2">
            <!--Distributor Name--->
            <div class="col-lg-6 col-xl-6 mb-1">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <!-- @focus="onFocusHandler" -->
                  <!-- :required="item.required" -->
                  <input
                    id="d_company_name"
                    name="d_company_name"
                    v-validate="'required'"
                    v-model="Distributors[1]['fieldvalue']"
                    placeholder="."
                    v-b-tooltip.hover
                    :title="$t('d_company_name')"
                  />
                  <label> {{ $t("d_company_name") }}</label>
                </div>
                <!--Tooltip :title="$t('cinema_type_name')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('d_company_name')">{{
                  errors.first("d_company_name")
                }}</span>
              </p>
            </div>

            <!--Parent Distributor Name--->
            <div class="col-lg-6 col-xl-6 mb-1">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      Distributors[2]['dropdownSelected'].length
                        ? 'shift-up'
                        : ''
                    "
                    >{{ $tc(Distributors[2]["label"], 1) }}</label
                  >
                  <b-dropdown
                    :text="Distributors[2]['dropdownSelected']"
                    variant="dropdown-curve"
                    class="w-100"
                    v-b-tooltip.hover
                    :title="$t(Distributors[2]['tooltip'])"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Parent Distributor"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchParent()"
                        v-on:keydown="onSearchParent()"
                        v-on:search="onSearchParent()"
                        v-model="searchParent"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in distributorList"
                      :key="dropdownIndex"
                      @click="
                        onDropdownChange(
                          $event,
                          Distributors[2]['label'],
                          dropdownItem,
                          2
                        )
                      "
                      >{{ dropdownItem.d_company_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <!--Tooltip :title="$t('cinema_type_name')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('parentdistributor')">{{
                  errors.first("parentdistributor")
                }}</span>
              </p>
            </div>

            <!---------------------------------------------Address Section------------------------------------->

            <div class="mx-3 back-white w-100 row pt-3 mb-3">
              <div class="col-12">
                <h5 class="heading">Address</h5>
              </div>
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="dropdown-curve-container">
                  <multiselect
                    :options="countryList"
                    v-model="selected_country"
                    :searchable="true"
                    label="country_name"
                    track-by="country_name"
                    placeholder="Select Country"
                    @select="onSelectCountry($event, 14)"
                    @remove="onRemoveCountry(14)"
                    v-b-tooltip.hover
                    :title="$t(Distributors[14]['tooltip'])"
                  ></multiselect>
                </div>
              </div>

              <!--State-->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="dropdown-curve-container">
                  <multiselect
                    :options="stateList"
                    v-model="selected_state"
                    :searchable="true"
                    label="state_name"
                    track-by="state_name"
                    placeholder="Select State"
                    @select="onSelectState($event, 15)"
                    @remove="onRemoveState(15)"
                    v-b-tooltip.hover
                    :title="$t(Distributors[15]['tooltip'])"
                  ></multiselect>
                </div>
              </div>

              <!--City--->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      id="city_name"
                      name="city_name"
                      v-model="Distributors[16]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t('city_name')"
                    />
                    <label>{{ $tc("city_name", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('city_name')">{{
                    errors.first("city_name")
                  }}</span>
                </p>
              </div>

              <!--Address--->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      id="cine_address"
                      name="cine_address"
                      v-model="Distributors[12]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t('Address')"
                    />
                    <label>{{ $tc("cine_address", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('cine_address')">{{
                    errors.first("cine_address")
                  }}</span>
                </p>
              </div>

              <!---Country--->

              <!--Zip Code--->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      id="cine_pincode"
                      name="cine_pincode"
                      v-model="Distributors[13]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[13]['tooltip'])"
                    />
                    <label>{{ $tc("cine_pincode", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('cine_pincode')">{{
                    errors.first("cine_pincode")
                  }}</span>
                </p>
              </div>
            </div>
            <!---------------------------------------------Address Section Ends-------------------------------->

            <!---Tax Section--->
            <div class="mx-3 back-white w-100 row pt-3 mb-3">
              <div class="col-12">
                <h5 class="heading">Taxes</h5>
              </div>

              <!--TIN/UID--->
              <div class="col-lg-3 col-xl-3 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      :id="Distributors[7]['fieldname']"
                      :name="Distributors[7]['fieldname']"
                      v-model="Distributors[7]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[7]['tooltip'])"
                    />
                    <label>{{ $tc("tinnumber", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('tinnumber')">{{
                    errors.first("tinnumber")
                  }}</span>
                </p>
              </div>

              <!--iban--->
              <div class="col-lg-3 col-xl-3 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      :id="Distributors[8]['fieldname']"
                      :name="Distributors[8]['fieldname']"
                      v-model="Distributors[8]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[8]['tooltip'])"
                    />
                    <label>{{ $tc("iban_no", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('iban_no')">{{
                    errors.first("iban_no")
                  }}</span>
                </p>
              </div>

              <!--Tax Number-->
              <div class="col-lg-3 col-xl-3 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      :id="Distributors[9]['fieldname']"
                      :name="Distributors[9]['fieldname']"
                      v-model="Distributors[9]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[9]['tooltip'])"
                    />
                    <label>{{ $tc("taxnumber", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('taxnumber')">{{
                    errors.first("taxnumber")
                  }}</span>
                </p>
              </div>

              <!---Tax/Vat--->
              <div class="col-lg-3 col-xl-3 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input
                      :id="Distributors[10]['fieldname']"
                      :name="Distributors[10]['fieldname']"
                      v-model="Distributors[10]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[10]['tooltip'])"
                    />
                    <label>{{ $tc("taxtype", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('taxtype')">{{
                    errors.first("taxtype")
                  }}</span>
                </p>
              </div>
            </div>
            <!---Tax Section Ends--->

            <!---Other input section--->

            <!--Website Url-->
            <div class="col-lg-4 col-xl-4 mb-1">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <!-- @focus="onFocusHandler" -->
                  <!-- :required="item.required" -->
                  <input
                    :id="Distributors[5]['fieldname']"
                    :name="Distributors[5]['fieldname']"
                    v-model="Distributors[5]['fieldvalue']"
                    placeholder="."
                    v-b-tooltip.hover
                    :title="$t(Distributors[5]['tooltip'])"
                  />
                  <label>{{ $tc("website_url", 1) }}</label>
                </div>
                <!--Tooltip :title="$t('cinema_type_name')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('website_url')">{{
                  errors.first("website_url")
                }}</span>
              </p>
            </div>

            <!---Email Address--->
            <div class="col-lg-4 col-xl-4 mb-1">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <!-- @focus="onFocusHandler" -->
                  <!-- :required="item.required" -->
                  <input
                    :id="Distributors[6]['fieldname']"
                    :name="Distributors[6]['fieldname']"
                    v-model="Distributors[6]['fieldvalue']"
                    placeholder="."
                    v-b-tooltip.hover
                    :title="$t(Distributors[6]['tooltip'])"
                  />
                  <label>{{ $tc("emailid", 1) }}</label>
                </div>
                <!--Tooltip :title="$t('cinema_type_name')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('emailid')">{{
                  errors.first("emailid")
                }}</span>
              </p>
            </div>

            <!--Select Weekwise Contract--->
            <div class="col-lg-4 col-xl-4 mb-1">
              <div class="dropdown-curve-container">
                <multiselect
                  v-model="selected_contract_id"
                  @select="onSelectContract($event, 11)"
                  :placeholder="
                    Distributors[11]['fieldKey']
                      ? Distributors[11]['fieldKey']
                      : 'Select Contract'
                  "
                  :options="contracts"
                  label="contract_weekwise_name"
                  track-by="cbw_id"
                  :multiple="false"
                  v-b-tooltip.hover
                  :title="$t('select_contract_tooltip')"
                ></multiselect>
              </div>
              <div>
                <p class="error_message">
                  <span v-if="submitted && selected_contract_id == null"
                    >Please select weekwise contract.</span
                  >
                </p>
              </div>
            </div>

            <!---Number--->
            <div class="col-lg-4 col-xl-4 mb-2 pr-0">
              <div class="d-flex align-items-center">
                <div class="input-material row">
                  <div class="col-4">
                    <b-dropdown
                      :text="SelectedCountryCode ? SelectedCountryCode : 'Code'"
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      name="countrycode"
                      id="countrycode"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in countryList"
                        :key="countryIndex"
                        v-on:click="onSelectHandler('countrycode', countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="col-8 pl-1 pr-0">
                    <input
                      :id="Distributors[3]['fieldname']"
                      :name="Distributors[3]['fieldname']"
                      v-model="Distributors[3]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[3]['tooltip'])"
                    />
                    <label>{{ $t("contactno") }}</label>
                  </div>
                  <div>
                    <p class="error_message">
                      <span
                        v-if="submitted && Distributors[3]['fieldvalue'] == ''"
                        >Please enter contact number</span
                      >
                    </p>
                  </div>
                </div>
                <!--Tooltip :title="$t('user_mobile')" /-->
              </div>
              <p class="error_message" v-if="false">
                <span>{{ "Country Code Required." }}</span>
                <span>{{ " " }}</span>
                <span>{{}}</span>
              </p>
            </div>

            <!---Fax Number-->
            <div class="col-lg-4 col-xl-4 mb-2 pr-0">
              <div class="d-flex align-items-center">
                <div class="input-material row">
                  <div class="col-4">
                    <b-dropdown
                      :text="fax_country_code ? fax_country_code : 'Code'"
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                      name="countrycode"
                      id="countrycode"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in countryList"
                        :key="countryIndex"
                        v-on:click="
                          onSelectHandler('fax_country_code', countrycode)
                        "
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="col-8 pl-1 pr-0">
                    <input
                      :id="Distributors[4]['fieldname']"
                      :name="Distributors[4]['fieldname']"
                      v-model="Distributors[4]['fieldvalue']"
                      placeholder="."
                      v-b-tooltip.hover
                      :title="$t(Distributors[4]['tooltip'])"
                    />
                    <label>{{ $t("faxno") }}</label>
                  </div>
                </div>
                <!--Tooltip :title="$t('user_mobile')" /-->
              </div>
              <p class="error_message" v-if="false">
                <span>{{ "Country Code Required." }}</span>
                <span>{{ " " }}</span>
                <span>{{}}</span>
              </p>
            </div>

            <!---Remarks--->
            <div class="col-lg-4 col-xl-4 mb-1">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <!-- @focus="onFocusHandler" -->
                  <!-- :required="item.required" -->
                  <input
                    :id="Distributors[17]['fieldname']"
                    :name="Distributors[17]['fieldname']"
                    v-model="Distributors[17]['fieldvalue']"
                    placeholder="."
                    v-b-tooltip.hover
                    :title="$t(Distributors[17]['tooltip'])"
                  />
                  <label>{{ $tc("remark", 1) }}</label>
                </div>
                <!--Tooltip :title="$t('cinema_type_name')" /-->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('remark')">{{
                  errors.first("remark")
                }}</span>
              </p>
            </div>

            <!---Other input section Ends--->
          </div>

          <section class="mb-2 w-100 px-3 distributor-section-new">
            <div
              class="section-title mb-3 d-flex justify-content-between section-border section-border"
              v-b-toggle.maccsSection
              style="padding:6px;align-items:center"
            >
              <span class="fs">
                Add Maccs Details
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="maccsSection"
              class="mt-2"
              v-model="sectionCollapse.maccsSection"
            >
              <div>
                <div class="row border mx-0 rounded mb-2">
                    <div
                      class="col-12 pl-0 movie-version-box"
                      style="padding-bottom:0px;padding-right:0px"
                    >
                      <div
                        class="row w-100 px-0 m-0 justify-content-around align-items-center"
                      >
                        <div
                          class="col-lg-6 col-xl-3 align-self-center mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Maccs Box ID"
                                type="text"
                                v-model="maccs_details.maccs_box_id"
                              />
                              <label>Maccs Box ID</label>
                            </div>
                          </div>
                          <p class="error_message">
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-3 align-self-center mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Pro Cinema ID"
                                type="text"
                                v-model="maccs_details.procinema_id"
                              />
                              <label>Pro Cinema ID</label>
                            </div>
                          </div>
                          <p class="error_message">
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-6 align-self-center mb-2"
                          style="zoom:0.9;"
                        >
                        <!-- <label>FDS Member</label> -->
                          <div class="d-flex align-items-center">
                              <b-form-radio
                                :value="'Y'"
                                class="j-radio"
                                v-model="maccs_details.member_of_fds"
                              >
                                <div>
                                  <span>{{ "FDS Member" }}</span>
                                </div>
                              </b-form-radio>
                              <strong class="mx-3">OR</strong>

                              <b-form-radio
                                :value="'N'"
                                class="j-radio"
                                v-model="maccs_details.member_of_fds"
                              >
                                <div>
                                  <span>{{ "Participating without being member" }}</span>
                                </div>
                              </b-form-radio>
                          </div>
                          <p class="error_message">
                          </p>
                        </div>
                        <!-- <div
                          class="col-lg-6 col-xl-4 align-self-center mb-4"
                          style="zoom:0.8;"
                        >
                         <label>Participating MaccsBox without Being Member</label>
                          <div class="d-flex align-items-center">
                             <b-form-radio
                                :value="'Y'"
                                class="j-radio"
                                v-model="maccs_details.participating_in_maccsbox_without_being_member"
                              >
                                <div>
                                  <span>{{ "YES" }}</span>
                                </div>
                              </b-form-radio>
                              <strong class="mx-3">OR</strong>

                              <b-form-radio
                                :value="'N'"
                                class="j-radio"
                                v-model="maccs_details.participating_in_maccsbox_without_being_member"
                              >
                                <div>
                                  <span>{{ "No" }}</span>
                                </div>
                              </b-form-radio>
                          </div>
                          <p class="error_message">
                          </p>
                        </div> -->
                      </div>
                    </div>
                </div>
              </div>
            </b-collapse>
          </section>

          <section class="mb-2 w-100 px-3 distributor-section-new">
            <div
              class="section-title mb-3 d-flex justify-content-between section-border section-border"
              v-b-toggle.personSection
              style="padding:6px;align-items:center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $tc("distributor", 1) }} {{ $t("person") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="personSection"
              class="mt-2"
              v-model="sectionCollapse.personSection"
            >
              <div v-if="persons.length > 0">
                <div class="row border mx-0 rounded mb-2">
                  <div
                    class="col-12 pl-0 movie-version-box"
                    style="padding-top:26px;padding-bottom:0px;padding-right:0px"
                  >
                    <div
                      class="col-12 px-1"
                      v-for="(person, index) in persons"
                      :key="index"
                    >
                      <div
                        class="row w-100 px-0 m-0 justify-content-around align-items-center"
                      >
                        <div
                          class="col-lg-6 col-xl-2 px-1 align-self-center mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Name"
                                type="text"
                                v-model="person.name"
                                v-b-tooltip.hover
                                :title="$t('Full Name')"
                              />
                              <label>{{ $t("Name") }}</label>
                            </div>
                            <!--Tooltip :title="$t('Full Name')" /-->
                          </div>
                          <p class="error_message">
                            <span
                              v-if="person.submit && person.name.length == 0"
                              >Please enter the name</span
                            >
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-2 px-1 align-self-center mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Function"
                                type="text"
                                v-model="person.functionType"
                                v-b-tooltip.hover
                                :title="$t('Employer Functioning')"
                              />
                              <label>{{ $t("Function") }}</label>
                            </div>
                            <!--Tooltip :title="$t('Employer Functioning')" /-->
                          </div>
                          <p class="error_message">
                            <!-- <span
                              v-if="
                                person.submit && person.functionType.length == 0
                              "
                              >Please enter function of Employee</span
                            > -->
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-3 px-1 align-self-center mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <div
                              class="input-material d-flex align-items-center"
                            >
                              <div class="col-4 pl-0">
                                <b-dropdown
                                  :text="
                                    person.countryCode
                                      ? person.countryCode
                                      : 'Code'
                                  "
                                  variant="dropdown-curve"
                                  class="w-100 text-center mr-3"
                                  name="countrycode"
                                  id="countrycode"
                                  v-b-tooltip.hover
                                  :title="$t('Employer Contact Number')"
                                >
                                  <div class="px-2 pb-2">
                                    <input
                                      required
                                      autofocus
                                      type="search"
                                      placeholder="Search Code"
                                      class="form-control form-control-sm"
                                      v-on:keyup="
                                        onSearchCode($event.target.value)
                                      "
                                      v-on:keydown="
                                        onSearchCode($event.target.value)
                                      "
                                      v-on:search="
                                        onSearchCode($event.target.value)
                                      "
                                      v-model="searchCode"
                                    />
                                  </div>
                                  <b-dropdown-item
                                    href="#"
                                    v-for="(countrycode,
                                    countryIndex) in countryList"
                                    :key="countryIndex"
                                    v-on:click="
                                      onSelectPersonCountryCode(
                                        countrycode,
                                        index
                                      )
                                    "
                                    v-if="countrycode.country_mob_code != null"
                                    >{{
                                      countrycode.country_mob_code
                                    }}</b-dropdown-item
                                  >
                                </b-dropdown>
                              </div>
                              <div class="position-relative w-100">
                                <input
                                  placeholder="Contact Number"
                                  type="text"
                                  v-model="persons[index].contact"
                                />
                                <label>{{ $t("Phone_Number") }}</label>
                              </div>
                            </div>
                            <!--Tooltip :title="$t('Employer Contact Number')" /-->
                          </div>
                          <p class="error_message">
                            <!-- <span
                              v-if="
                                persons[index].submit &&
                                  persons[index].contact.length == 0
                              "
                              >Please enter Phone Number</span
                            > -->
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-2 px-1 align-self-center mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Email"
                                type="email"
                                v-model="persons[index].emailId"
                                v-b-tooltip.hover
                                :title="$t('Employer EmailId')"
                              />
                              <label>{{ $t("Email Address") }}</label>
                            </div>
                            <!--Tooltip :title="$t('Employer EmailId')" /--->
                          </div>
                          <p class="error_message">
                            <span
                              v-if="
                                persons[index].submit &&
                                  persons[index].emailId.length == 0
                              "
                              >Pleaase enter Email Address</span
                            >
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-1 px-1 justify-self-center align-self-center mb-2"
                        >
                          <!-- <div class="d-flex align-items-center"> -->
                          <button
                            @click.prevent.stop="removePeople($event, index)"
                            class="btn-transparent"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto mb-0" style="font-weight:600;color:black">
                    Add Distributor Person
                  </p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addPeople($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>
            <!-- <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("distributor", 1) }} {{$t('person')}}
      </div> -->
            <!-- <div
          class="row py-4 border mx-auto rounded w-100">
          <div class="add-person mx-auto">
              <button
              @click.prevent.stop="addPeople($event)"
              class="btn-transparent"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
            <span class="text-muted">Add Person</span>
          </div>
          </div> -->
          </section>
          <section class="mb-2 w-100 px-3 distributor-section-new">
            <div
              class="section-title mb-3 d-flex justify-content-between section-border section-border"
              v-b-toggle.otherTaxesSection
              style="padding:6px;align-items:center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $tc("distributor", 1) }} {{ $t("taxes") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="otherTaxesSection"
              class="mt-2"
              v-model="sectionCollapse.otherTaxesSection"
            >
              <div v-if="otherTaxes.length > 0">
                <div class="row border mx-0 rounded mb-2 ">
                  <div
                    class="col-12 pl-0 movie-version-box"
                    style="padding-top:26px;padding-bottom:0px;padding-right:0px"
                  >
                    <div
                      class="col-12 px-0"
                      v-for="(tax, index) in otherTaxes"
                      :key="index"
                    >
                      <div
                        class="row w-100 justify-content-around mx-0 align-items-center"
                      >
                        <div
                          class="col-lg-6 col-xl-2 align-self-center my-2 px-0"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Tax Name"
                                type="text"
                                id="tax_name"
                                name="tax_name"
                                v-model="tax.tax_name"
                                v-validate="'required'"
                                v-b-tooltip.hover
                                :title="$t('tax_name')"
                              />
                              <label>{{ $t("tax_name") }}</label>
                            </div>
                            <!--Tooltip :title="$t('tax_name')" /--->
                          </div>
                          <p class="error_message">
                            <span v-if="submitted && !tax.tax_name">{{
                              $t("tax_name_required")
                            }}</span>
                          </p>
                        </div>
                        <div
                          class="col-lg-6 col-xl-2 px-0 align-self-center my-2"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="Tax Value"
                                type="number"
                                id="tax_value"
                                name="tax_value"
                                v-model="tax.tax_value"
                                v-validate="'required'"
                                v-b-tooltip.hover
                                :title="$t('tax_value')"
                              />
                              <label>{{ $t("tax_value") }}</label>
                            </div>
                            <!--Tooltip :title="$t('tax_value')" /--->
                          </div>
                          <p class="error_message">
                            <span v-if="submitted && !tax.tax_value">{{
                              $t("tax_value_required")
                            }}</span>
                          </p>
                        </div>

                        <div
                          class="col-lg-6 col-xl-2 px-0 align-self-center my-2 pb-4"
                        >
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              type="checkbox"
                              class="j-checkbox mb-0 pb-0"
                              v-model="tax.is_percentage"
                            />

                            <label class="mb-0 mr-3">{{
                              $t("Percentage")
                            }}</label>
                          </div>
                        </div>

                        <div
                          class="col-lg-6 col-xl-2 px-0 align-self-center my-2 pb-4"
                        >
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              type="checkbox"
                              class="j-checkbox mb-0 pb-0"
                              v-model="tax.is_per_ticket"
                            />

                            <label class="mb-0 mr-3">{{
                              $t("is_per_ticket")
                            }}</label>
                          </div>
                        </div>
                        <div
                          class="col-lg-6 col-xl-2 px-0 align-self-center my-2 pb-4"
                        >
                          <button
                            @click.prevent.stop="removeOtherTax($event, index)"
                            class="btn-transparent"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto mb-0" style="font-weight:600;color:black">
                    Add Distributor Taxes
                  </p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addOtherTaxes($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>

            <!-- <div
          class="row py-4 border mx-auto rounded w-100">
          <div class="add-person mx-auto">
              <button
              @click.prevent.stop="addOtherTaxes($event)"
              class="btn-transparent"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
            <span class="text-muted">Add Distributor Taxes</span>
          </div>
          </div> -->
          </section>
          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="handleSubmit(true)"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="handleSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click.prevent.stop="resetHandler" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="distributors"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Distributors from "@/helper/formJSONMaster/Distributors";
import DistributorService from "@/services/DistributorService";
export default {
  data() {
    return {
      distributorListCopy: [],
      searchParent: "",
      selected_country: {},
      selected_state: null,
      selected_city: null,
      selected_contract_id: null,
      SelectedCountryCode: "",
      countrydet: null,
      searchCode: "",
      btenable: false,
      Distributors: Distributors.organizations,
      submitted: false,
      Methods: Distributors.Methods,
      countryList: [],
      Countries: [],
      CodeListCopy: [],
      stateList: [],
      distributorList: [],
      cityList: [],
      contracts: [],
      fax_country_code: "",

      maccs_details: {
        maccs_box_id: null,
        procinema_id: null,
        member_of_fds: 'N',
        participating_in_maccsbox_without_being_member: 'N',
      },

      showAddPeopleForm: false,
      person: {
        name: "",
        functionType: "",
        contact: "",
        bookingContact: "",
        emailId: "",
        countryCode: ""
      },
      otherTaxes: [],
      persons: [],
      count: 0,
      sectionCollapse: {
        personSection: false,
        otherTaxesSection: false,
        maccsSection: false,
      }
    };
  },
  beforeMount() {
    this.getCountryList();
    this.getDistributorList();
    this.getWeekWiseContractList();
    this.resetHandler();
    this.getDefaultDistributorTax();
    // hack not the correct way to do it
  },
  mounted() {
    console.log("Distributors :", Distributors);
  },
  updated() {
    // hack not a proper way to do it
    if (this.persons.length > 0) {
      this.persons.map(x => {
        x.countryCode = this.SelectedCountryCode;
      });
    }
    // this.persons[0].countryCode = this.SelectedCountryCode;
  },
  methods: {
    addPeople() {
      let person = {
        name: "",
        functionType: "",
        contact: "",
        bookingContact: "",
        emailId: "",
        countryCode: this.SelectedCountryCode,
        submit: false
      };
      this.persons.push(person);
    },
    removePeople(event, index) {
      this.persons.splice(index, 1);
    },
    addOtherTaxes() {
      let tax = {
        tax_name: "",
        tax_value: "",
        is_percentage: false,
        is_per_ticket: false
      };
      this.otherTaxes.push(tax);
    },
    removeOtherTax(event, index) {
      this.otherTaxes.splice(index, 1);
    },
    onSearchParent: function() {
      if (this.searchParent && this.searchParent.length > 0) {
        this.distributorList = this.distributorListCopy.filter(x => {
          if (
            x.d_company_name
              .toLowerCase()
              .includes(this.searchParent.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.distributorList = this.distributorListCopy;
      }
    },
    onSelectCountry(Country, mainIndex) {
      this.Distributors[mainIndex].fieldvalue = Country.country_id;
      this.Distributors[mainIndex].dropdownSelected = Country.country_name;
      this.selected_state = null;
      this.selected_city = null;
      this.Distributors[mainIndex + 1].fieldvalue = null;
      this.Distributors[mainIndex + 1].dropdownSelected = "";
      this.Distributors[mainIndex + 2].fieldvalue = null;
      this.Distributors[mainIndex + 2].dropdownSelected = "";
      this.getStateList(Country.country_id);
      console.log(
        "this.Distributors[mainIndex] country :",
        this.Distributors[mainIndex]
      );
    },
    onSelectState(State, mainIndex) {
      this.Distributors[mainIndex].dropdownSelected = State.state_name;
      this.Distributors[mainIndex].fieldvalue = State.state_id;
      this.selected_city = null;
      this.Distributors[mainIndex + 1].fieldvalue = null;
      this.Distributors[mainIndex + 1].dropdownSelected = "";
      this.getCityList(State.state_id);
      console.log(
        "this.Distributors[mainIndex] state :",
        this.Distributors[mainIndex]
      );
    },
    onSelectCity(City, mainIndex) {
      this.Distributors[mainIndex].dropdownSelected = City.city_name;
      this.Distributors[mainIndex].fieldvalue = City.city_id;
    },
    onSelectContract(event, index) {
      console.log("event :>> ", event);
      console.log("index :>> ", index);
      this.Distributors[index].fieldvalue = event.cbw_id;
      this.Distributors[index].dropdownSelected = event.contract_weekwise_name;
    },
    onRemoveCountry(mainIndex) {
      this.Distributors[mainIndex + 1].fieldvalue = null;
      this.Distributors[mainIndex + 1].dropdownSelected = "";
      this.Distributors[mainIndex + 2].fieldvalue = null;
      this.Distributors[mainIndex + 2].dropdownSelected = "";
      this.stateList = [];
      this.selected_state = null;
      this.cityList = [];
      this.selected_city = null;
    },
    onRemoveState(mainIndex) {
      this.Distributors[mainIndex + 1].fieldvalue = null;
      this.Distributors[mainIndex + 1].dropdownSelected = "";
      console.log(
        " this.Distributors[mainIndex+1] :",
        this.Distributors[mainIndex + 1]
      );
      this.cityList = [];
      this.selected_city = null;
    },
    onRemoveCity(mainIndex) {
      this.Distributors[mainIndex].dropdownSelected = "";
      this.Distributors[mainIndex].fieldvalue = null;
    },

    getDistributorList: function() {
      MasterService.GetDistributors()
        .then(response => {
          const { data } = response;
          if (data.data && data.data.length > 0) {
            console.log("response GetDistributors:", response);
            this.distributorList = data.data;
            this.distributorListCopy = data.data;
          } else {
            // Show Errors
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getWeekWiseContractList: function() {
      DistributorService.GetAllWeekWiseContractList()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.contracts = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },

    onFocusHandler: function() {
      // this.submitted = false;
    },

    resetHandler: function() {
      this.Distributors.map(x => {
        if (x.type === "text" || x.type === "date" || x.type === "number") {
          x.fieldvalue = "";
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });

      this.selected_country = null;
      this.selected_state = null;
      this.selected_city = null;
      this.selected_contract_id = null;
      this.SelectedCountryCode = "";

      this.maccs_details = {
        maccs_box_id: null,
        procinema_id: null,
        member_of_fds: 'N',
        participating_in_maccsbox_without_being_member: 'N',
      }
    },

    getStateList: function(id) {
      this.stateList = [];
      this.cityList = [];
      let payload = {
        tableName: "ms_states",
        state_is_active: "Y",
        country_id: id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.stateList = data.Records;
            this.Distributors.map(x => {
              if (x.fieldname === "state_id") {
                x.dropdownSelected = "Select State";
                x.fieldvalue = "";
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    getCountryList: function() {
      this.countryList = [];
      this.stateList = [];
      this.cityList = [];
      this.Countries = [];
      this.CodeListCopy = [];
      let payload = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;

            let globalOptions = this.$store.getters.getGlobalOptions;
            if (this.countryList.length > 0 && globalOptions.length > 0) {
              let operationCountryId = globalOptions.find(data => {
                return data.go_key === "OPERATION_COUNTRY";
              });
              let countryInfo = this.countryList.find(data => {
                return data.country_id == operationCountryId.go_value;
              });
              this.selected_country = { ...countryInfo };
              this.SelectedCountryCode = countryInfo.country_mob_code;
              this.fax_country_code = countryInfo.country_mob_code;
              this.getStateList(countryInfo.country_id);
            }
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    getCityList: function(id) {
      this.cityList = [];
      let payload = {
        tableName: "ms_cities",
        city_is_active: "Y",
        state_id: id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.cityList = data.Records;
            this.Distributors.map(x => {
              if (x.fieldname === "city_id") {
                x.dropdownSelected = "Select City";
                x.fieldvalue = "";
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onDropdownChange: function(event, type, item, mainIndex) {
      console.log("mainIndex :", mainIndex);
      if (type === "country") {
        this.Distributors[mainIndex].fieldvalue = item.country_id;
        this.Distributors[mainIndex].dropdownSelected = item.country_name;
        this.getStateList(item.country_id);
        console.log(
          " this.Distributors[mainIndex] :",
          this.Distributors[mainIndex]
        );
        this.setDropdownHandler(["state", "city"]);
      } else if (type === "state") {
        this.Distributors[mainIndex].dropdownSelected = item.state_name;
        this.Distributors[mainIndex].fieldvalue = item.state_id;
        this.getCityList(item.state_id);
        this.setDropdownHandler(["city"]);
      } else if (type === "city") {
        this.Distributors[mainIndex].dropdownSelected = item.city_name;
        this.Distributors[mainIndex].fieldvalue = item.city_id;
      } else if (type == "parentdistributor") {
        this.Distributors[mainIndex].dropdownSelected = item.d_company_name;
        this.Distributors[mainIndex].fieldvalue = item.d_id;
        (this.searchParent = ""), this.onSearchParent();
      }
    },
    setDropdownHandler: function(resetList) {
      this.Distributors.map(y => {
        let array = resetList.filter(x => `${x}_id` == y.fieldname);
        if (array.length > 0) {
          y.dropdownSelected = `Select ${array[0]}`;
          y.fieldvalue = "";
        }
      });
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter(x => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    onSelectHandler(type, value, index) {
      if (type == "countrycode") {
        this.countrydet = value;
        this.SelectedCountryCode = value.country_mob_code;
      } else if (type == "fax_country_code") {
        this.fax_country_code = value.country_mob_code;
      }
    },
    onSelectPersonCountryCode(code, index) {
      this.persons[index].countryCode = code.country_mob_code;
    },
    validateEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    getDefaultDistributorTax() {
      // let loader = this.$loader.show();
      MasterService.GetDefaultDistributorTax()
        .then(response => {
          const { data } = response;
          if (data.Records && data.status && data.Records.length > 0) {
            data.Records.map(x => {
              let tax = {
                tax_name: x.tax_name,
                tax_value: x.tax_value,
                is_percentage: x.is_percentage == "Y" ? true : false,
                is_per_ticket: x.is_per_ticket == "Y" ? true : false
              };
              this.otherTaxes.push(tax);
            });
            this.sectionCollapse.otherTaxesSection = true;
          } else {
            console.log("No Default Taxes");
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          // loader.hide();
        });
    },
    handleSubmit(flag) {
      this.submitted = true;
      // validation for persons data
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          for (let index = 0; index < this.persons.length; index++) {
            this.persons[index].submit = true;
            this.persons[index].d_people_contact_withoutchar = this.persons[
              index
            ].contact.replace("/[^0-9]/ig", "");
            this.persons[
              index
            ].d_peopel_booking_contact_withoutchar = this.persons[
              index
            ].bookingContact.replace("/[^0-9]/ig", "");
          }
          for (let index = 0; index < this.persons.length; index++) {
            // if (this.persons[index].name === "") return;
            // if (this.persons[index].functionTyp === "") return;
            // if (this.persons[index].contact === "") return;
            // if (this.persons[index].bookigContact === "") return;
            if (this.validateEmail(this.persons[index].emailId) == false) {
              this.$toasted.show("Email id is incorrect");
              return;
            }
            // if (this.persons[index].countryCode === "") return;
          }
          if (this.otherTaxes.length > 0) {
            this.otherTaxes.map(y => {
              if (y.tax_name == "") {
                return;
              } else if (y.tax_value == "") {
                return;
              }
            });
          }
          let countryInfo = this.countryList.find(data => {
            return data.country_mob_code == this.SelectedCountryCode;
          });
          let body = this.getRequestBody(
            "POST",
            this.Distributors,
            this.Methods
          );

          body.payload.parent_distributor_id =
            body.parent_distributor_id === ""
              ? body.payload.parent_distributor_id
              : null;
          body.payload.country_id = countryInfo.country_id;

          body.payload.country_mob_code = this.SelectedCountryCode;
          body.payload.fax_country_code = this.fax_country_code
            ? this.fax_country_code
            : this.SelectedCountryCode;
          body.payload.d_contact_no = this.Distributors[3].fieldvalue.replace(
            "/[^0-9]/ig",
            ""
          );

          body.payload.persons = this.persons;
          body.payload.otherTaxes = this.otherTaxes;
          Object.keys(this.maccs_details).map((key) => {
            body.payload[key] = this.maccs_details[key]
          })
          MasterService.GlobalRequest(body)
            .then(response => {
              this.btenable = false;
              console.log("====================>", response);
              const { data } = response;
              if (data.status) {
                this.resetHandler();
                if (flag) {
                  this.$router.push({
                    path: "/distributor/distributors"
                  });
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch(error => {
              console.log("show error2 :", error);
            });
        } else {
          this.submitted = true;

          console.log("else :");
        }
      });
    }
  }
};
</script>
<style>
.distributor-section-new .input-material input {
  background-color: white !important;
}
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border-new {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
}
.internal-border {
  border: 1px solid #3876d2;
  background-color: #e6e6f8;
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
}
.fs {
  font-size: 17px;
}
.back {
  background-color: #f5f5f5;
}
.mar {
  margin-left: 30px;
}
.back-white {
  background-color: white;
  border: 1px solid #b1b4b8;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorsComponents/addDistributor.vue